import { Message } from 'element-ui'
import store from '../store'

export function handleErrorResponse(error) {
    if (error.request.status === 401) {
        store.dispatch('FedLogOut').then(() => {
            location.reload()
        })
    } else if (error.request.status === 422) {
        let message = error.response.data.message || "Authorization data is incorrect";
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
    } else if (error.request.status === 423 || error.request.status === 500) {
        const { data } = error.response
        let message = data ? data.message : error.message
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
    } else {
        Message({
            message: error.response?.data?.message || "An unknown error occurred",
            type: 'error',
            duration: 5 * 1000
        })
    }

    return Promise.reject(error)
}
